var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterKeywordIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 32,
    viewBox: "0 0 43 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.3604 11.602H3.06108C1.37797 11.602 0 10.2282 0 8.5502V3.05182C0 1.3738 1.37797 0 3.06108 0H39.3604C41.0435 0 42.4215 1.3738 42.4215 3.05182V8.5502C42.4215 10.2282 41.0435 11.602 39.3604 11.602Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0711 21.8111C39.7585 21.6605 39.8291 21.241 39.2285 20.876L26.9521 13.3761C26.3546 13.0111 26.0141 13.2641 26.2004 13.9397L29.981 27.7898C30.1673 28.4655 30.5913 28.5135 30.9286 27.9019L32.1652 25.6378C32.5025 25.023 33.1192 24.9782 33.5432 25.5386L37.343 30.5918C37.7638 31.1522 38.5668 31.2675 39.1289 30.8448L39.6107 30.4861C40.1728 30.0666 40.2885 29.2661 39.8645 28.7057L36.0646 23.6556C35.6438 23.0952 35.859 22.5156 36.5464 22.3651L39.0711 21.8111Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterKeywordIcon);
export default __webpack_public_path__ + "static/media/filter_keyword_icon.ad507b202662655948d3b258499b9a09.svg";
export { ForwardRef as ReactComponent };